import { Context, Provider, createContext, useContext } from 'react';

type SafeContextResult<T> = [() => T, Provider<T | null>, Context<T | null>];

/**
 * A `createContext` wrapper whose hook throws (instead of silently returning a
 * default) when used outside its provider. Internal to the terminal package.
 */
export function createSafeContext<T>(
  displayName: string,
): SafeContextResult<T> {
  const Ctx = createContext<T | null>(null);
  Ctx.displayName = displayName;

  function useCtx(): T {
    const value = useContext(Ctx);
    if (value === null) {
      throw new Error(`Missing ${displayName} provider upwards on this tree`);
    }
    return value;
  }

  return [useCtx, Ctx.Provider, Ctx];
}
